/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "underscore";
import * as elementActions from "../../../redux/actions/elements";
import * as userActions from "../../../redux/actions/user";
import { defaultCurrency } from "../../../shared/constants/currency";
import * as productConstants from "../../../shared/constants/product";
import * as orderRepo from "../../../shared/repos/graphql/order";
import * as productRepo from "../../../shared/repos/graphql/product";
import * as rendering from "../../../shared/utilities/renderings";

import { orderMethods, orderTypeIds } from "../../../shared/constants/order";
import { shippingMethods, storeIds } from "../../../shared/constants/store";

import DeliveryPickUpWidget from "../../../components/DeliveryPickUpWidget/DeliveryPickUpWidget";
import Loader from "../../../components/Loader/Loader";
// COMPONENTS
import CheckoutCartButton from "../../../components/CheckoutCartButton/CheckoutCartButton";
import DiscountTag from "../../../components/DiscountTag/DiscountTag";
import GiftToggle from "../../../components/GiftToggle/GiftToggle";
import QuickCheckoutButton from "../../../components/QuickCheckoutButton/QuickCheckoutButton";

import ProductOptions from "../../../components/ProductOptions/ProductOptions";
import SizeChart from "../../../components/SizeChart/SizeChart";

import * as tagmanagerEvents from "../../../shared/utilities/tagmanagerEvents";
import endpoints from "../../../shared/constants/endpoints";
import { historyAction } from "../../../shared/constants/history";
import {
  handleProductWithDirectLink,
  sortOptionByPreset
} from "../../../shared/utilities/product";
import styles from "./CustomizeProduct.module.css";
import { requestProductFulfillment } from "../../../shared/utilities/productFulfillment";

import * as loyaltyAction from "../../../redux/actions/loyalty";
import { store } from "../../../redux/store";
import errorCodes from "../../../shared/constants/errorCodes";
import { PUNCHH_TYPE } from "../../../shared/constants/loyaltyType";
import {
  getErrorMessages,
  getErrorReasons,
  routeCountryPath
} from "../../../shared/utilities/common";
import { isBrandRefreshEnabled } from "../../../shared/utilities/brandRefresh";
import amplitudeAnalytics, {
  AMPLITUDE_NAV_SECTION_SECONDARY,
  formatAmplitudeSuggestedItemCategory,
  getAmplitudeSuggestedItemPageNameForPdp,
} from "../../../shared/utilities/amplitude";
import { calculateLoyaltyPoints } from "../../../shared/utilities/loyalty";
import { openOrderUpdateFailModal } from "../../../shared/utilities/modals";
import {
  clearCart,
  isDeliveryOrPickup
} from "../../../shared/utilities/orders";
import {
  hasAvailableSleeveOptions,
  isBoxProduct,
  filterOutSleeveOptions
} from "../../../shared/utilities/sleeves";
import {
  getCustomizeSelectionProgress,
  isCustomizeCheckoutEnabled
} from "../../../shared/utilities/pdpSelectionProgress";
import PresetBoxes from "../PresetBoxes/PresetBoxes";
import PdpStickySelectionHeader from "../PdpStickySelectionHeader/PdpStickySelectionHeader";
import { getCartErrorMessage } from "../../../shared/utilities/cart";
import BrandRefreshButtonSpinner from "../../../components/BrandRefreshButtonSpinner/BrandRefreshButtonSpinner";
import brStyles from "./CustomizeProductBrandRefresh.module.css";

const backIcon = require("../imgs/back-icon.svg");
const lightBackIcon = require("../imgs/light-back-icon.svg");
const brBackIcon = require("./images/back-chevron-brand-refresh.svg");
const brCaretDown = require("./images/caret-down.svg");

class CustomizeProduct extends Component {
  constructor(props) {
    super(props);
    const { history } = this.props;
    this.state = {
      item: null,
      customizeProducts: null,
      productPrice: 0.0,
      quantity: 1,
      updateCartLoading: false,
      updatePriceLoading: false,
      productAddError: "",
      locationKey: history.location.key,
      points: 0,
      presetSelectionId: 0,
      isGift: false,
      showQuantitySelector: false
    };

    this.productTitleRef = React.createRef();
    this.actionsRef = React.createRef();
    this.qtyTriggerRef = React.createRef();
    this.qtyDropdownRef = React.createRef();
    this.actionsStickyBound = false;
    this.actionsStickyRaf = null;
  }

  async componentDidMount() {
    await this.setProductData();
    handleProductWithDirectLink(this);
    if (isBrandRefreshEnabled()) {
      this.bindBrandRefreshActionsStickyRelease();
      this.syncBrandRefreshHeaderClearance();
    }
  }

  async componentDidUpdate(prevProps, prevState = {}) {
    const { selectedStore, history, location, order, match } = this.props;
    const { locationKey, showQuantitySelector } = this.state;
    const poid = match?.params?.poid;
    const { showQuantitySelector: prevShowQuantitySelector } = prevState;

    if (selectedStore && selectedStore !== prevProps.selectedStore) {
      await this.setProductData();
    }
    // [17607] When order loads after mount (modify flow), hydrate line item
    if (poid && order !== prevProps.order) {
      const selectedItem = this.getOrderLineItem(poid);
      const { item, isGift: currentIsGift } = this.state;
      const needsFullLineHydrate =
        Boolean(selectedItem) &&
        (!item || String(item.id) !== String(selectedItem.id));

      if (needsFullLineHydrate) {
        // Intentional: rebuild qty/options/gift once the order line is available
        await this.setProductData({ forceLineHydrate: true }); // eslint-disable-line react/no-did-update-set-state
      } else if (
        selectedItem?.isGift !== undefined &&
        selectedItem.isGift !== currentIsGift
      ) {
        // Intentional: sync gift flag when order line updates
        this.setState({ isGift: Boolean(selectedItem.isGift) }); // eslint-disable-line react/no-did-update-set-state
      }
    }
    if (history.action === historyAction.pop && location.key !== locationKey) {
      history.goBack();
    }
    if (isBrandRefreshEnabled()) {
      this.bindBrandRefreshActionsStickyRelease();
      this.syncBrandRefreshActionsStickyRelease();
      this.syncBrandRefreshHeaderClearance();
    } else {
      this.unbindBrandRefreshActionsStickyRelease();
      this.teardownBrandRefreshHeaderClearance();
    }
    if (showQuantitySelector && !prevShowQuantitySelector) {
      this.bindQuantitySelectorDismiss();
      this.scrollBrandRefreshQtyDropdownToSelected();
    } else if (!showQuantitySelector && prevShowQuantitySelector) {
      this.unbindQuantitySelectorDismiss();
    }
  }

  componentWillUnmount() {
    this.unbindBrandRefreshActionsStickyRelease();
    this.unbindQuantitySelectorDismiss();
    this.teardownBrandRefreshHeaderClearance();
  }

  /**
   * Keep the selected qty near the bottom of the open list (e.g. "2" above
   * "1") instead of leaving scrollTop at 0 with "20" at the top.
   */
  scrollBrandRefreshQtyDropdownToSelected = () => {
    window.requestAnimationFrame(() => {
      const dropdown = this.qtyDropdownRef.current;
      if (!dropdown) {
        return;
      }
      const selected = dropdown.querySelector(
        '[data-part="qty-option"][data-selected="true"]'
      );
      if (!selected) {
        return;
      }
      dropdown.scrollTop = Math.max(
        0,
        selected.offsetTop + selected.offsetHeight - dropdown.clientHeight
      );
    });
  };

  /** Cart line items from order (source of truth). Do not use state.user.userCart. */
  getOrderLineItems = () => {
    const { order } = this.props;
    if (!order) {
      return [];
    }
    if (Array.isArray(order.items)) {
      return order.items;
    }
    if (Array.isArray(order.products)) {
      return order.products;
    }
    return [];
  };

  getOrderLineItem = poid => {
    if (poid == null || poid === "") {
      return undefined;
    }
    return this.getOrderLineItems().find(
      item => String(item.id) === String(poid)
    );
  };

  closeQuantitySelector = () => {
    const { showQuantitySelector } = this.state;
    if (showQuantitySelector) {
      this.setState({ showQuantitySelector: false });
    }
  };

  handleQuantitySelectorKeyDown = event => {
    if (event.key === "Escape") {
      event.preventDefault();
      this.closeQuantitySelector();
      if (this.qtyTriggerRef.current) {
        this.qtyTriggerRef.current.focus();
      }
    }
  };

  handleQuantitySelectorOutsideClick = event => {
    const actions = this.actionsRef.current;
    if (actions && !actions.contains(event.target)) {
      this.closeQuantitySelector();
    }
  };

  bindQuantitySelectorDismiss = () => {
    document.addEventListener(
      "mousedown",
      this.handleQuantitySelectorOutsideClick
    );
    document.addEventListener("keydown", this.handleQuantitySelectorKeyDown);
  };

  unbindQuantitySelectorDismiss = () => {
    document.removeEventListener(
      "mousedown",
      this.handleQuantitySelectorOutsideClick
    );
    document.removeEventListener("keydown", this.handleQuantitySelectorKeyDown);
  };

  /**
   * Desktop sticky CTA: hide the fade gradient only when the bar has
   * released with the info card (end of product section / footer in view).
   */
  syncBrandRefreshActionsStickyRelease = () => {
    if (this.actionsStickyRaf) {
      return;
    }
    this.actionsStickyRaf = window.requestAnimationFrame(() => {
      this.actionsStickyRaf = null;
      const el = this.actionsRef.current;
      if (!el) {
        return;
      }
      if (!window.matchMedia("(min-width: 992px)").matches) {
        if (el.getAttribute("data-released")) {
          el.removeAttribute("data-released");
        }
        return;
      }
      const parent = el.closest("[data-part='info-card']");
      if (!parent) {
        return;
      }
      const released =
        parent.getBoundingClientRect().bottom <= window.innerHeight + 1;
      const isReleased = el.getAttribute("data-released") === "true";
      if (released && !isReleased) {
        el.setAttribute("data-released", "true");
      } else if (!released && isReleased) {
        el.removeAttribute("data-released");
      }
    });
  };

  bindBrandRefreshActionsStickyRelease = () => {
    if (this.actionsStickyBound) {
      return;
    }
    this.actionsStickyBound = true;
    window.addEventListener(
      "scroll",
      this.syncBrandRefreshActionsStickyRelease,
      { passive: true }
    );
    window.addEventListener(
      "resize",
      this.syncBrandRefreshActionsStickyRelease
    );
    this.syncBrandRefreshActionsStickyRelease();
  };

  unbindBrandRefreshActionsStickyRelease = () => {
    if (!this.actionsStickyBound) {
      return;
    }
    this.actionsStickyBound = false;
    window.removeEventListener(
      "scroll",
      this.syncBrandRefreshActionsStickyRelease
    );
    window.removeEventListener(
      "resize",
      this.syncBrandRefreshActionsStickyRelease
    );
    if (this.actionsStickyRaf) {
      window.cancelAnimationFrame(this.actionsStickyRaf);
      this.actionsStickyRaf = null;
    }
    const el = this.actionsRef.current;
    if (el && el.getAttribute("data-released")) {
      el.removeAttribute("data-released");
    }
  };

  /**
   * Body already has padding for part of the fixed header; add the remaining
   * shortfall so photo/info cards clear the sticky nav with breathing room.
   * Mirrors SingleProduct brand-refresh header clearance, with the same
   * banner / headerWrapper fallbacks as PdpStickySelectionHeader.
   */
  syncBrandRefreshHeaderClearance = () => {
    if (!isBrandRefreshEnabled()) {
      return;
    }

    const getHeaderEl = () =>
      document.querySelector('header[role="banner"]') ||
      document.querySelector('[role="banner"]') ||
      document.querySelector('[class*="headerWrapper"]') ||
      document.querySelector("header");

    const applyClearance = () => {
      const wrapper = document.querySelector(
        '[data-region="customize-product-pdp"]'
      );
      const header = getHeaderEl();
      if (!wrapper) {
        return;
      }
      if (!header) {
        wrapper.style.setProperty("--bp-header-clearance", "0px");
        return;
      }
      const headerBottom = header.getBoundingClientRect().bottom;
      const bodyPad =
        parseFloat(window.getComputedStyle(document.body).paddingTop) || 0;
      const shortfall = Math.max(0, Math.round(headerBottom - bodyPad));
      wrapper.style.setProperty("--bp-header-clearance", `${shortfall}px`);
    };

    applyClearance();

    if (
      typeof ResizeObserver !== "undefined" &&
      !this.brandRefreshHeaderObserver
    ) {
      const header = getHeaderEl();
      if (header) {
        this.brandRefreshHeaderObserver = new ResizeObserver(applyClearance);
        this.brandRefreshHeaderObserver.observe(header);
      }
    }
  };

  teardownBrandRefreshHeaderClearance = () => {
    if (this.brandRefreshHeaderObserver) {
      this.brandRefreshHeaderObserver.disconnect();
      this.brandRefreshHeaderObserver = null;
    }
  };

  handleBackToMenu = () => {
    const { history, location, selectedStore } = this.props;
    const isShippingStore =
      selectedStore && selectedStore.id === storeIds.shipping;

    amplitudeAnalytics.trackClickNavSecondary({
      navElement: "Back to Menu",
      navSection: AMPLITUDE_NAV_SECTION_SECONDARY.PRODUCT_PAGE,
      pathname: location?.pathname
    });
    history.push(
      routeCountryPath(
        isShippingStore
          ? endpoints.shippingPage
          : endpoints.getMenuUrl(selectedStore)
      )
    );
  };

  openAddressSelectionModal = () => {
    const { setModalObject } = this.props;
    const { product } = this.state;
    setModalObject({
      fullscreenChildren: true,
      children: (
        <DeliveryPickUpWidget
          isModal
          productId={product?.id}
          analyticsPageSection="Product Image"
        />
      )
    });
  };

  /**
   * BR CTA: mirror SingleProduct — open address modal without flipping the
   * loading spinner when store/order method is missing (Carlos: Add to Order
   * was not adding; spinner stuck + no cart write).
   */
  handleBrandRefreshAddItem = () => {
    const { userOrderMethod, selectedStore } = this.props;
    const { product } = this.state;
    if (product?.oos === 1) {
      return undefined;
    }
    if (this.requestFulfillment()) return undefined;

    if (userOrderMethod === orderMethods.shipping) {
      return this.handleAddItem();
    }

    const needsStore =
      isDeliveryOrPickup(userOrderMethod) ||
      userOrderMethod === orderMethods.eGiftCard;

    if (needsStore && selectedStore) {
      return this.handleAddItem();
    }

    if (needsStore && !selectedStore) {
      return this.openAddressSelectionModal();
    }

    return this.openAddressSelectionModal();
  };

  setProductData = async ({ forceLineHydrate = false } = {}) => {
    const {
      match,
      loyalty,
      redeemables,
      isShowOosProducts,
      productId
    } = this.props;
    const { params } = match;
    const { poid } = params;
    const selectedItem = this.getOrderLineItem(poid);

    const { customizeProducts, quantity } = this.state;
    let selectedOptions = customizeProducts;
    this.setState({
      updatePriceLoading: true,
      updateCartLoading: true,
      item: selectedItem
    });
    const id = productId ?? params.id;
    const redeemableId = redeemables?.redeemableId
      ? redeemables?.redeemableId
      : null;
    const { data } = await productRepo.getProduct(
      id,
      redeemableId,
      isShowOosProducts
    );
    const { product } = data;

    this.setState(prevState => ({
      product,
      productPrice: product.price,
      updatePriceLoading: false,
      updateCartLoading: false,
      // Set isGift from selectedItem if editing, otherwise keep current value
      isGift: selectedItem?.isGift ?? prevState.isGift
    }));

    const shouldHydrateOptions =
      !selectedOptions || (forceLineHydrate && Boolean(selectedItem));
    if (shouldHydrateOptions) {
      selectedOptions = rendering.getSelectedOptions(product, selectedItem);
    }
    if (selectedItem) {
      this.setState({
        quantity: selectedItem.quantity || 1
      });
    } else if (!quantity) {
      this.setState({
        quantity: 1
      });
    }
    const { customizeProducts: options } = rendering.reconcileProductSelections(
      product,
      selectedOptions,
      { autoFill: shouldHydrateOptions }
    );
    this.setState({ customizeProducts: options });
    if (loyalty) {
      this.getProductLoyaltyPoints(loyalty, id, poid);
    }
  };

  getProductLoyaltyPoints = (loyalty, id, poid) => {
    const {
      order,
      loyaltyPoints,
      loyaltyDeals,
      loyaltyRedeemables,
      history
    } = this.props;
    const loyaltyProducts =
      loyalty === PUNCHH_TYPE.REDEEMABLE ? loyaltyRedeemables : loyaltyDeals;
    try {
      const points = calculateLoyaltyPoints(
        loyalty,
        id,
        poid,
        loyaltyPoints,
        loyaltyProducts,
        order
      );
      this.setState({
        points
      });
    } catch (error) {
      history.push(endpoints.loyalty);
    }
  };

  /**
   * Handler for when an option is added or remove.
   *
   * @author Elizabeth Clouser <elizabeth@somepage.com>
   */
  updateOptions = customizeProducts => {
    this.setState({ customizeProducts });
  };

  /**
   * Check to see if obj/param has data/value
   *
   * @param {any} obj
   */
  isEmpty = obj => {
    if (obj == null) return true;
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    if (typeof obj !== "object") return true;

    return true;
  };

  handleProductUpdate = async () => {
    const {
      userCartId,
      history,
      loyalty,
      redeemables,
      setUserCart
    } = this.props;
    const {
      item,
      product,
      quantity,
      customizeProducts,
      presetSelectionId,
      isGift
    } = this.state;

    const customizeProductsArray = [];
    Object.values(customizeProducts).forEach(array =>
      array.forEach(el => customizeProductsArray.push(el))
    );

    const productArrayWithCategoryOptionId = [];
    Object.entries(customizeProducts).forEach(([key, value]) => {
      productArrayWithCategoryOptionId.push({
        productIds: value,
        groupOptionId: key
      });
    });

    // console.debug("handleProductUpdate.isGift", isGift);

    if (product?.title != null && product?.id != null) {
      amplitudeAnalytics.trackUpdateItem({
        productName: product.title,
        productId: product.id,
      });
    }

    let updateRes;
    try {
      updateRes = await orderRepo.addUpdateOrderProduct(userCartId, {
        orderProductId: parseInt(item.id, 10),
        product: product.id,
        quantity,
        price: product.price,
        productOptions: productArrayWithCategoryOptionId,
        redeemableId:
          loyalty === PUNCHH_TYPE.REDEEMABLE ? redeemables?.redeemableId : null,
        dealId: loyalty === PUNCHH_TYPE.DEALS ? redeemables?.redeemableId : null,
        presetSelectionId,
        isGift
      });
    } catch (reason) {
      this.setState({
        updateCartLoading: false,
        productAddError: getCartErrorMessage(reason)
      });

      return;
    }

    if (!updateRes) {
      this.setState({ updateCartLoading: false });
      return;
    }

    tagmanagerEvents.addToCart({
      ...product,
      quantity,
      price: (product.price * quantity).toFixed(2)
    });

    // Header badge still reads state.user.userCart (Box/Single PDP parity).
    // Without this sync, GraphQL add succeeds but the cart icon stays empty.
    const updatedOrder = updateRes.data.updateProductOrder;
    setUserCart(updatedOrder.items.map(lineItem => lineItem));
    history.push(routeCountryPath(`/checkout/view-order/`));
  };

  handleAddItemToCart = async (orderCode, quickCheckout = false, fulfillment) => {
    const {
      history,
      userOrderMethod,
      loyalty,
      loyaltyPoints,
      redeemables,
      location,
      currency,
      setUserCart
    } = this.props;

    const {
      product,
      quantity,
      customizeProducts,
      points,
      presetSelectionId,
      isGift
    } = this.state;

    const customizeProductsArray = [];
    const productArrayWithCategoryOptionId = [];
    Object.values(customizeProducts).forEach(array =>
      array.forEach(el => customizeProductsArray.push(el))
    );

    Object.entries(customizeProducts).forEach(([key, value]) => {
      productArrayWithCategoryOptionId.push({
        productIds: value,
        groupOptionId: key
      });
    });
    // Assign cake topper image ID to specific it's product
    const urlParams = new URLSearchParams(window.location.search);
    const isUpsaleString = urlParams.get("isUpsale");
    const isUpsale = isUpsaleString === "true";
    const data = {
      product: product.id,
      quantity,
      productOptions: productArrayWithCategoryOptionId,
      isUpsale,
      redeemableId:
        loyalty === PUNCHH_TYPE.REDEEMABLE ? redeemables?.redeemableId : null,
      dealId: loyalty === PUNCHH_TYPE.DEALS ? redeemables?.redeemableId : null,
      presetSelectionId,
      isGift: Boolean(isGift)
    }; // correct order

    // console.debug("Adding product with data:", data);

    // Capture current orderProductIds so we can identify the newly created one later
    const existingOrderProductIds = new Set();
    this.getOrderLineItems().forEach(item =>
      existingOrderProductIds.add(String(item.id))
    );

    if (quickCheckout) {
      tagmanagerEvents.clickQuickCheckout({
        ...product,
        quantity,
        price: (product.price * quantity).toFixed(2)
      });
    } else {
      tagmanagerEvents.addToCart({
        ...product,
        quantity,
        price: (product.price * quantity).toFixed(2)
      });
    }

    let result;
    try {
      result = await orderRepo.addProductToOrder(orderCode, data, {
        pathname: location?.pathname,
        source: 'customize_product',
        currencySymbol: currency?.symbol || '$',
      });
      if (loyalty) {
        store.dispatch(loyaltyAction.loyaltyPoints(loyaltyPoints - points));
      }
    } catch (reason) {
      this.setState({
        updateCartLoading: false,
        productAddError: getCartErrorMessage(reason)
      });

      return {};
    }

    const updatedOrder = result.data.addProductToOrderV2;
    // Header badge still reads state.user.userCart (Box/Single PDP parity).
    // Without this sync, GraphQL add succeeds but the cart icon stays empty.
    const localStorageCart = updatedOrder.items.map(lineItem => lineItem);
    setUserCart(localStorageCart);

    const cartSuggestedPage = getAmplitudeSuggestedItemPageNameForPdp(
      location?.pathname,
      location?.search
    );
    if (cartSuggestedPage && isUpsale) {
      amplitudeAnalytics.trackAddSuggestedItem({
        pageName: cartSuggestedPage,
        productCategory: formatAmplitudeSuggestedItemCategory(product.categories),
        productName: product.title,
        productId: product.id,
      });
    }

    if (quickCheckout) {
      return result;
    }

    // Check if gift toggle is enabled and redirect to sleeve selection
    if (isGift && hasAvailableSleeveOptions(product)) {
      const newlyAddedItem = updatedOrder.items.find(
        item => !existingOrderProductIds.has(String(item.id))
      );
      const selectedOrderProduct =
        newlyAddedItem ||
        updatedOrder.items.find(item => item.product?.id === product.id) ||
        updatedOrder.items[0];

      if (selectedOrderProduct?.id) {
        const orderProductId = selectedOrderProduct.id;

        // Include orderProductId in the URL for reliability; keep state for backward compatibility
        history.push(
          routeCountryPath(
            `/products/box/${product.id}/options/${orderProductId}`
          ),
          {
            orderProductId
          }
        );
        return {};
      }
    }

    const addLink =
      (fulfillment || userOrderMethod) === orderMethods.shipping
        ? endpoints.shippingPage
        : endpoints.menu;
    history.push(routeCountryPath(addLink));

    return {};
  };

  setCartStates = () => {
    const { history } = this.props;

    clearCart();
    history.push(routeCountryPath(endpoints.getMenuUrl(null)));
  };

  handleCartCreateError = reason => {
    const { setModalObject } = this.props;
    // Always clear CTA loading — createCart failures previously left the
    // spinner stuck (same class of bug as Carlos #1 address-modal path).
    this.setState({ updateCartLoading: false });
    const message = getErrorMessages(reason, 0);
    const reasonType = getErrorReasons(reason, 0);
    const createReason = reasonType === errorCodes.CART_CREATE_ERROR;
    if (createReason) {
      setModalObject(openOrderUpdateFailModal(message, this.setCartStates));
    }
  };

  handleShipping = async () => {
    const { userCartId, setUserCartId } = this.props;
    const { customizeProducts } = this.state;
    const customizeProductsArray = [];

    Object.values(customizeProducts).forEach(array =>
      array.forEach(el => customizeProductsArray.push(el))
    );

    if (userCartId) {
      return this.handleAddItemToCart(userCartId, false);
    }

    const data = {
      orderTypeId: orderTypeIds.shipping,
      shippingMethod: shippingMethods.shipping,
      storeId: storeIds.shipping
    };

    try {
      const response = await orderRepo.createCart(data);

      const { createCart } = response.data;
      setUserCartId(createCart.code);

      return this.handleAddItemToCart(createCart.code, false);
    } catch (reason) {
      this.handleCartCreateError(reason);
      return null;
    }
  };

  handlePickupDelivery = async (quickCheckout = false) => {
    const {
      userOrderMethod,
      selectedStore,
      userCartId,
      setUserCartId
    } = this.props;
    const { customizeProducts } = this.state;

    const customizeProductsArray = [];
    Object.values(customizeProducts).forEach(array =>
      array.forEach(el => customizeProductsArray.push(el))
    );

    if (selectedStore) {
      if (!userCartId) {
        let orderTypeId = null;
        let shippingMethod = null;

        if (userOrderMethod === orderMethods.delivery) {
          orderTypeId = 2;
          shippingMethod = 4;
        } else if (userOrderMethod === orderMethods.pickup) {
          orderTypeId = 3;
          shippingMethod = 3;
        }
        let storeId = null;
        if (selectedStore && selectedStore.id) {
          storeId = selectedStore.id;
        }

        const data = {
          orderTypeId,
          shippingMethod,
          storeId
        };

        try {
          const res = await orderRepo.createCart(data);
          const { createCart } = res.data;
          setUserCartId(createCart.code);
          return this.handleAddItemToCart(createCart.code, quickCheckout);
        } catch (reason) {
          this.handleCartCreateError(reason);
        }
      }
      return this.handleAddItemToCart(userCartId, quickCheckout);
    }

    this.setState({ updateCartLoading: false });
    return true;
  };

  requestFulfillment = () => requestProductFulfillment(this, code =>
    this.handleAddItemToCart(code, false, orderMethods.shipping)
  );

  handleAddItem = () => {
    const { userOrderMethod, updateProduct } = this.props;
    const { product } = this.state;
    if (product.oos === 1) {
      return {};
    }
    if (this.requestFulfillment()) return {};

    this.setState({
      updateCartLoading: true,
      productAddError: ""
    });

    if (updateProduct) {
      return this.handleProductUpdate();
    }

    if (userOrderMethod === orderMethods.shipping) {
      return this.handleShipping();
    }

    if (isDeliveryOrPickup(userOrderMethod)) {
      return this.handlePickupDelivery();
    }

    // Address modal — do not leave CTA stuck in loading
    this.setState({ updateCartLoading: false });
    return this.openAddressSelectionModal();
  };

  handleQuickCheckout = async () => {
    const { userOrderMethod, userCartId } = this.props;
    const { product } = this.state;
    if (product.oos === 1) {
      return {};
    }
    if (this.requestFulfillment()) return {};
    this.setCartLoading(true);

    if (isDeliveryOrPickup(userOrderMethod)) {
      const orderProductIds = _.pluck(this.getOrderLineItems(), "id");
      if (orderProductIds.length) {
        await orderRepo.removeProducts(userCartId, orderProductIds);
      }

      const [res] = await Promise.all([this.handlePickupDelivery(true)]);
      const { addProductToOrderV2 } = res.data;

      return { addProductToOrderV2 };
    }

    return {};
  };

  setCartLoading = value => {
    this.setState({ updateCartLoading: value });
  };

  getOptionTotals = () => {
    const { product, customizeProducts } = this.state;

    return rendering.getOptionTotal(product, customizeProducts);
  };

  clearPresets = async () => {
    await this.setProductData();
    this.setState({ customizeProducts: {}, presetSelectionId: 0 });
  };

  onSelect = preset => {
    const { product } = this.state;

    const selections = {};

    preset.optionGroups.forEach(optionGroup => {
      selections[optionGroup.id] = [];

      optionGroup.options.forEach(option => {
        const optionId = option.productId.toString();

        for (let i = 1; i <= option.quantity; i++) {
          selections[optionGroup.id].push(optionId);
        }
      });
    });

    const { customizeProducts } = rendering.reconcileProductSelections(
      product,
      selections
    );

    product.options = sortOptionByPreset(product.options, customizeProducts);
    product.productImage = preset.image;
    this.setState({
      customizeProducts,
      presetSelectionId: +preset.id
    });
  };

  setElement = element => {
    this.setState({
      productOptionElement: element // eslint-disable-line
    });
  };

  customizeProductContainer = () => {
    const {
      history,
      updateProduct,
      selectedStore,
      designId,
      cakeTopperProductId,
      cakeTopperUrl,
      isCaloriesActive,
      currency,
      loyalty,
      selectedPreset,
      useFullscreenCarousel,
    } = this.props;
    const {
      product,
      quantity,
      customizeProducts,
      updateCartLoading,
      productAddError,
      productPrice,
      updatePriceLoading,
      points,
      isGift
    } = this.state;
    if (!product) {
      return (
        <div className={styles.pageLoaderWrapper}>
          <Loader />
        </div>
      );
    }

    const storeId = selectedStore ? selectedStore.id : storeIds.sampleMenu;

    const checkoutEnabled = this.isCheckoutEnabled();
    const isDisabled = !checkoutEnabled || updateCartLoading;
    const totalCost =
      selectedStore && !updatePriceLoading
        ? (productPrice + this.getOptionTotals()).toFixed(2)
        : null;
    const addProductText = selectedStore
      ? productConstants.ADD_TO_ORDER_TEXT
      : productConstants.ADD_TO_ORDER_NO_ADDRESS_TEXT;
    const outOfStockText = productConstants.OUT_OF_STOCK_TEXT;
    const addUpdateProductText = updateProduct
      ? productConstants.UPDATE_PRODUCT_TEXT
      : addProductText;
    const productPriceItem =
      selectedStore && !updatePriceLoading
        ? `${currency.symbol}${productPrice.toFixed(2)}`
        : null;
    const calories =
      isCaloriesActive && product.calories != null
        ? ` ${product.calories} kCal`
        : "";
    const header = product.metaHeading || product.title;
    const selectionProgress = getCustomizeSelectionProgress(
      product.options,
      customizeProducts
    );
    const showStickySelectionHeader =
      isBrandRefreshEnabled() && selectionProgress.requiredCount > 0;
    return (
      <div
        className={`${styles.customizePageContainer} flex justify-between gap-8`}
      >
        {showStickySelectionHeader ? (
          <PdpStickySelectionHeader
            productName={header}
            selectedCount={selectionProgress.selectedCount}
            requiredCount={selectionProgress.requiredCount}
            onBack={this.handleBackToMenu}
            observeTargetRef={this.productTitleRef}
            observeKey={product.id}
          />
        ) : null}
        <div className={styles.customizeImageContainer}>
          {cakeTopperProductId === product.id && designId ? (
            <img
              alt={`${product.title} custom cake topper design`}
              src={`${cakeTopperUrl}/${designId}`}
            />
          ) : (
            <img alt={`${product.title} product`} src={product.productImage} />
          )}
        </div>
        <div className={`${styles.customizeDetailsContainer}`}>
          <div
            className={`${styles.detailsHeader} flex flex-col gap-4 items-start`}
          >
            <div className={`${styles.backMenu}`}>
              <div
                onClick={this.handleBackToMenu}
                className="w-full flex text-dark dark:text-white items-center gap-4 font-montserratBold"
              >
                <span>
                  <img alt="" src={backIcon} className="block dark:hidden" />
                  <img
                    alt=""
                    src={lightBackIcon}
                    className="hidden dark:block"
                  />
                </span>
                Back to Menu
              </div>
            </div>
            {loyalty ? (
              <span className=" text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
                {points}
                {" pts"}
                {rendering.renderLoyaltyPrice(this)}
              </span>
            ) : productPriceItem ? (
              <div className="flex items-center gap-2">
                {product.strike_price ? (
                  <span className="text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
                    <strike>
                      {currency.symbol}
                      {parseFloat(product.strike_price).toFixed(2)}
                    </strike>
                    &nbsp;
                    {productPriceItem}
                  </span>
                ) : (
                  <span className="text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
                    {productPriceItem}
                  </span>
                )}
                <DiscountTag discountPercent={product.discountPercent} />
              </div>
            ) : null}
            <h1
              ref={this.productTitleRef}
              className="font-congenialRegular font-bold text-[44px] leading-[46px] tracking-[-1px] text-dark dark:text-white"
            >
              {header}
            </h1>
          </div>

          <p className="text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
            {product.description}
            {" "}
            <span className="text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
              {calories}
            </span>
          </p>
          <div>
            {product.nutritionInfoLink ? (
              <h2
                className={`${styles.nutritionalInfo} text-[#983992] font-montserratBold text-lg leading-[22px] tracking-[-0.1px]`}
              >
                <a
                  href={product.nutritionInfoLink}
                  target="blank"
                  className="text-[#983992] font-montserratBold text-lg leading-[22px] tracking-[-0.1px]"
                >
                  Nutritional info
                </a>
              </h2>
            ) : null}
          </div>
          <SizeChart product={product} />

          {/* Gift Toggle - only show if sleeve options are available and in stock */}
          {hasAvailableSleeveOptions(product) && isBoxProduct(product) && (
            <GiftToggle
              isGift={isGift}
              onChange={value => this.setState({ isGift: value })}
            />
          )}

          <PresetBoxes
            productId={product.id}
            onSelect={this.onSelect}
            selectedPreset={selectedPreset}
            onClear={this.clearPresets}
            storeId={storeId}
            currency={currency}
            includePersonalizedPreset={false}
            pdpProductId={product.id}
            pdpProductTitle={product.metaHeading || product.title}
          />

          <ProductOptions
            options={filterOutSleeveOptions(product.options)}
            onOptionChange={this.updateOptions}
            customizeProducts={customizeProducts}
            setElement={this.setElement}
            isCaloriesActive={isCaloriesActive}
            currency={currency}
            tags={product.metaTags}
            pdpProductId={product.id}
            pdpProductTitle={product.metaHeading || product.title}
          />

          <div className={styles.cartWrapper}>
            {updateCartLoading ? (
              <div className={styles.loaderWrapper}>
                <Loader />
              </div>
            ) : null}
            <CheckoutCartButton
              onClick={() => {
                this.handleAddItem();
              }}
              isDisabled={isDisabled}
              label={product.oos === 1 ? outOfStockText : addUpdateProductText}
              price={loyalty ? points : totalCost}
              onQuantityChange={value => this.setState({ quantity: value })}
              quantity={loyalty ? null : quantity}
              loyalty={loyalty}
              boldLabel={useFullscreenCarousel}
            />

            <QuickCheckoutButton
              addProductToCart={this.handleQuickCheckout}
              setCartLoading={this.setCartLoading}
              isDisabled={isDisabled}
              product={product}
              history={history}
            />
            {productAddError.length ? (
              <p className={styles.errorMessage}>{productAddError}</p>
            ) : null}
          </div>
        </div>
      </div>
    );
  };

  brandRefreshContainer = () => {
    const {
      updateProduct,
      selectedStore,
      designId,
      cakeTopperProductId,
      cakeTopperUrl,
      isCaloriesActive,
      currency,
      loyalty,
      selectedPreset
    } = this.props;
    const {
      product,
      quantity,
      customizeProducts,
      updateCartLoading,
      productAddError,
      productPrice,
      updatePriceLoading,
      points,
      isGift,
      showQuantitySelector
    } = this.state;

    if (!product) {
      return (
        <div className={brStyles.pageWrapper}>
          <div data-part="page-loader">
            <Loader />
          </div>
        </div>
      );
    }

    const storeId = selectedStore ? selectedStore.id : storeIds.sampleMenu;
    const currencySymbol = (currency && currency.symbol) || "$";
    const selectionProgress = getCustomizeSelectionProgress(
      product.options,
      customizeProducts
    );
    const checkoutEnabled = selectionProgress.isCheckoutEnabled;
    const btnDisabled =
      !checkoutEnabled || updateCartLoading || product.oos === 1;
    const qty = quantity || 1;
    const totalCostRaw =
      selectedStore && !updatePriceLoading
        ? (Number(productPrice) + this.getOptionTotals()) * qty
        : null;
    const formattedTotalCost =
      totalCostRaw != null && !Number.isNaN(totalCostRaw)
        ? totalCostRaw.toFixed(2)
        : null;
    const addProductText = selectedStore
      ? productConstants.ADD_TO_ORDER_TEXT
      : productConstants.ADD_TO_ORDER_NO_ADDRESS_TEXT;
    const outOfStockText = productConstants.OUT_OF_STOCK_TEXT;
    const cta = updateProduct
      ? productConstants.UPDATE_PRODUCT_TEXT
      : addProductText;
    const productPriceItem =
      selectedStore && !updatePriceLoading
        ? Number(productPrice).toFixed(2)
        : null;
    const header = product.metaHeading || product.title;
    const calories =
      isCaloriesActive && product.calories != null
        ? ` ${product.calories} kCal`
        : "";

    const remaining = Math.max(
      0,
      selectionProgress.requiredCount - selectionProgress.selectedCount
    );
    // Label stays action-only; cash/points render on the right.
    let ctaButtonText;
    if (product.oos === 1) {
      ctaButtonText = outOfStockText;
    } else if (!checkoutEnabled && remaining > 0) {
      ctaButtonText = `Pick ${remaining} more`;
    } else if (!checkoutEnabled) {
      ctaButtonText = "Adjust selections";
    } else {
      ctaButtonText = cta;
    }
    let ctaPriceText = null;
    if (product.oos !== 1) {
      if (loyalty) {
        ctaPriceText = `${points} pts`;
      } else if (formattedTotalCost != null) {
        ctaPriceText = `${currencySymbol}${formattedTotalCost}`;
      }
    }

    const showStickySelectionHeader = selectionProgress.requiredCount > 0;
    const showCtaQuantity = !loyalty;
    const quantityValues = _.range(
      productConstants.PRODUCT_MAX_QUANTITY_SELECTION,
      0
    );
    const showCashPrice = !loyalty;

    return (
      <div
        className={brStyles.pageWrapper}
        data-region="customize-product-pdp"
      >
        {showStickySelectionHeader ? (
          <PdpStickySelectionHeader
            productName={header}
            selectedCount={selectionProgress.selectedCount}
            requiredCount={selectionProgress.requiredCount}
            onBack={this.handleBackToMenu}
            observeTargetRef={this.productTitleRef}
            observeKey={product.id}
          />
        ) : null}
        <div data-part="pdp-inner">
          <div data-part="photo-card">
            {cakeTopperProductId === product.id && designId ? (
              <img
                alt={`${product.title} custom cake topper design`}
                src={`${cakeTopperUrl}/${designId}`}
              />
            ) : (
              <img alt={`${product.title} product`} src={product.productImage} />
            )}
          </div>

          <div data-part="info-card">
            <button
              type="button"
              data-part="back-link"
              onClick={this.handleBackToMenu}
            >
              <img
                alt=""
                src={brBackIcon}
                data-part="back-icon"
                aria-hidden="true"
              />
              Back to Menu
            </button>

            <div data-part="product-details">
              {product.discountPercent > 0 ? (
                <DiscountTag
                  discountPercent={product.discountPercent}
                  isBrandRefresh
                />
              ) : null}
              <div data-part="title-row">
                <h1 data-part="product-title" ref={this.productTitleRef}>
                  {header}
                </h1>

                {loyalty ? (
                  <div data-part="price-row">
                    <span data-part="loyalty-points">
                      {points}
                      {" pts"}
                    </span>
                    {rendering.renderLoyaltyPrice(this)}
                  </div>
                ) : showCashPrice && productPriceItem ? (
                  <div data-part="price-row">
                    {product.strike_price ? (
                      <>
                        <span data-part="price-strike">
                          {currencySymbol}
                          {parseFloat(product.strike_price).toFixed(2)}
                        </span>
                        <span>
                          {currencySymbol}
                          {productPriceItem}
                        </span>
                      </>
                    ) : (
                      <span>
                        {currencySymbol}
                        {productPriceItem}
                      </span>
                    )}
                  </div>
                ) : null}
              </div>

              <div data-part="product-copy">
                <p data-part="product-description">
                  {product.description}
                  {calories}
                </p>
                {product.nutritionInfoLink ? (
                  <a
                    data-part="nutrition-link"
                    href={product.nutritionInfoLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Nutritional info
                  </a>
                ) : null}
              </div>

              <SizeChart product={product} />

              {hasAvailableSleeveOptions(product) && isBoxProduct(product) ? (
                <GiftToggle
                  isGift={isGift}
                  onChange={value => this.setState({ isGift: value })}
                  isBrandRefresh
                />
              ) : null}

              <PresetBoxes
                productId={product.id}
                onSelect={this.onSelect}
                selectedPreset={selectedPreset}
                onClear={this.clearPresets}
                storeId={storeId}
                currency={currency}
                includePersonalizedPreset={false}
                pdpProductId={product.id}
                pdpProductTitle={product.metaHeading || product.title}
                isBrandRefresh
              />

              <div data-part="options">
                <ProductOptions
                  options={filterOutSleeveOptions(product.options)}
                  onOptionChange={this.updateOptions}
                  customizeProducts={customizeProducts}
                  setElement={this.setElement}
                  isCaloriesActive={isCaloriesActive}
                  currency={currency}
                  tags={product.metaTags}
                  pdpProductId={product.id}
                  pdpProductTitle={product.metaHeading || product.title}
                  isBrandRefresh
                />
              </div>
            </div>

            <div data-part="actions" ref={this.actionsRef}>
              {/* Figma 8498:78324 — BR CTA is qty + Add only; Quick Checkout stays on legacy shell (same as Box #18954). */}
              <div
                data-part="add-btn"
                data-loading={updateCartLoading ? "true" : undefined}
                data-disabled={btnDisabled ? "true" : "false"}
              >
                {showQuantitySelector && showCtaQuantity ? (
                  <div
                    id="customize-br-qty-listbox"
                    data-part="qty-dropdown"
                    role="listbox"
                    aria-label="Quantity"
                    ref={this.qtyDropdownRef}
                  >
                    {quantityValues.map(value => (
                      <button
                        type="button"
                        key={value.toString()}
                        role="option"
                        data-part="qty-option"
                        data-selected={value === quantity ? "true" : "false"}
                        aria-selected={value === quantity}
                        onClick={e => {
                          e.stopPropagation();
                          this.setState({
                            quantity: value,
                            showQuantitySelector: false
                          });
                        }}
                      >
                        {value}
                      </button>
                    ))}
                  </div>
                ) : null}
                {showCtaQuantity ? (
                  <button
                    type="button"
                    ref={this.qtyTriggerRef}
                    data-part="qty-trigger"
                    aria-label="Select quantity"
                    aria-haspopup="listbox"
                    aria-expanded={showQuantitySelector}
                    aria-controls="customize-br-qty-listbox"
                    disabled={btnDisabled}
                    onClick={e => {
                      e.stopPropagation();
                      if (!btnDisabled) {
                        this.setState(prev => ({
                          showQuantitySelector: !prev.showQuantitySelector
                        }));
                      }
                    }}
                  >
                    <span data-part="qty-value">{qty}</span>
                    <img src={brCaretDown} alt="" data-part="qty-caret" />
                  </button>
                ) : null}
                <button
                  type="button"
                  data-part="add-btn-main"
                  data-loading={updateCartLoading ? "true" : undefined}
                  aria-busy={updateCartLoading ? "true" : undefined}
                  disabled={btnDisabled}
                  onClick={() => this.handleBrandRefreshAddItem()}
                >
                  {updateCartLoading ? (
                    <BrandRefreshButtonSpinner />
                  ) : (
                    <>
                      <span data-part="add-btn-label">{ctaButtonText}</span>
                      {ctaPriceText ? (
                        <span data-part="add-btn-price">{ctaPriceText}</span>
                      ) : null}
                    </>
                  )}
                </button>
              </div>
              {productAddError.length ? (
                <p data-part="error-message">{productAddError}</p>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  };

  isCheckoutEnabled() {
    const { product, customizeProducts } = this.state;
    const options =
      product && Array.isArray(product.options) ? product.options : [];
    return isCustomizeCheckoutEnabled(options, customizeProducts);
  }

  render() {
    if (isBrandRefreshEnabled()) {
      return <this.brandRefreshContainer />;
    }
    return <this.customizeProductContainer />;
  }
}

CustomizeProduct.propTypes = {
  cakeTopperProductId: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  cakeTopperUrl: PropTypes.string,
  isCaloriesActive: PropTypes.bool,
  isShowOosProducts: PropTypes.bool,
  currency: PropTypes.objectOf(PropTypes.string),
  useFullscreenCarousel: PropTypes.bool
};

CustomizeProduct.defaultProps = {
  cakeTopperProductId:
    window.environment.REACT_APP_CUSTOM_CAKE_TOPPER_PRODUCT_ID,
  cakeTopperUrl: window.environment.REACT_APP_CUSTOM_CAKE_TOPPER_URL,
  isCaloriesActive: false,
  isShowOosProducts: false,
  currency: defaultCurrency,
  useFullscreenCarousel: isBrandRefreshEnabled()
};

export const mapDispatchToProps = dispatch => ({
  setUserCart: value => dispatch(userActions.setUserCart(value)),
  setUserCartId: value => dispatch(userActions.setUserCartId(value)),
  setModalObject: value => dispatch(elementActions.setModalObject(value)),
  setStoreId: value => dispatch(userActions.setSelectedStore(value)),
  setUserOrderMethodId: value =>
    dispatch(userActions.setUserOrderMethod(value)),
  setUserAddress: value => dispatch(userActions.setUserAddress(value))
});

export const mapStateToProps = state => {
  const {
    userOrderMethod,
    selectedStore,
    userCartId,
    userInfo
  } = state.user;
  const { designId } = state.customCakeTopper;
  const { isCaloriesActive, isShowOosProducts } = state.product;
  const { currency } = state.currency;
  const {
    loyaltyRedeemables,
    loyaltyDeals,
    loyaltyPoints,
    redeemables
  } = state.loyalty;
  const { order } = state;
  return {
    userOrderMethod,
    selectedStore,
    userCartId,
    userInfo,
    designId,
    isCaloriesActive,
    isShowOosProducts,
    currency,
    loyaltyRedeemables,
    loyaltyDeals,
    loyaltyPoints,
    order,
    redeemables
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CustomizeProduct)
);
